import { Route, Routes } from "react-router-dom";
import BranchAssignmentCreateScreen from "screens/App/CRM/BranchAssignment/BranchAssignmentCreateScreen";
import BranchAssignmentDetailScreen from "screens/App/CRM/BranchAssignment/BranchAssignmentDetailScreen";
import BranchAssignmentEditScreen from "screens/App/CRM/BranchAssignment/BranchAssignmentEditScreen";
import BranchAssignmentListScreen from "screens/App/CRM/BranchAssignment/BranchAssignmentListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const BranchAssignmentRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<BranchAssignmentCreateScreen />} />
      <Route path="list" element={<BranchAssignmentListScreen />} />
      <Route path=":id/detail" element={<BranchAssignmentDetailScreen />} />
      <Route path=":id/edit" element={<BranchAssignmentEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default BranchAssignmentRouter;
